import { createRef, RefObject } from 'react';
import { ITreeNodeValue, Key } from './Tree.interfaces';
export class TreeNode {
  constructor(key, value, parent = null) {
    this.ref = /*#__PURE__*/createRef();
    this.key = key;
    this.value = value;
    this.parent = parent;
    this.children = [];
    this.expanded = false;
    this.tabindex = -1;
  }
  get isLeaf() {
    return this.children.length === 0;
  }
  get hasChildren() {
    return !this.isLeaf;
  }
}